// ** Type Imports
import { OwnerStateThemeType } from "../";

const Autocomplete = () => {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: ({ theme }: OwnerStateThemeType) => ({}),
      },
    },
  };
};

export default Autocomplete;
